<!--
Indicator can switch between 4 states:
0: invisible
1: visible and showing spinner
2: visible and showing checkmark
3: visible and showing 'X'
-->
<template>
  <div class="indicatorWrapper">
    <span v-if="props.status === 1"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></span>
    <span v-if="props.status === 2" class="icon-check"></span>
    <span v-if="props.status === 3" class="icon-close"></span>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'

const props = defineProps({
  status: Number // can be enum from outside this component
})
</script>

<style scoped lang="scss">
div.indicatorWrapper{
  @apply flex justify-center items-center;
  font-size: 16px;
  color: $black;
  span.icon-check {
    font-size: 22px;
  }
  .lds-ring{
    display: inline-block;
    position: relative;
    width: 22px;
    height: 22px;
  }
  .lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 22px;
    height: 22px;
    margin: 2px;
    border: 1px solid $black;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: $black transparent transparent transparent;
  }
}
</style>
